module.exports = __webpack_public_path__ + "static/media/certificate.fd3350ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate.jpg
// module id = 2685
// module chunks = 2